import * as z from 'zod/mini';

export const PackageSessionQuotationRequestSchema = z.object({
  order_session_id: z.string(),
  office_id: z.number(),
  department_id: z.number(),
  locale: z.string(),
  email: z.string(),
  name: z.string(),
  message: z.nullish(z.string()),
  url: z.httpUrl(),
});

export const PackageSessionQuotationResponseSchema = z.object({
  message: z.string(),
});
